// extracted by mini-css-extract-plugin
export var Subtitle = "Subtitle-module--Subtitle--72bce";